import { api } from "./api";

export const cashOutApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCashOut: builder.query({
      query: () => "api/Fin/CashOut",
      providesTags: ["cashOut"],
    }),
    addCashOut: builder.mutation({
      query: (formData) => ({
        url: "api/Fin/CashOut",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["cashOut"],
    }),
  }),
});

export const { useGetCashOutQuery, useAddCashOutMutation } = cashOutApi;
